/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { useLingui } from '@lingui/react';
import { jsx } from 'theme-ui';

// We need to define the valid currency translations so the numberFormat doesn't throw errors.
const currencies = {
  $: 'USD',
  USD: 'USD',
  US$: 'USD',
  '€': 'EUR',
  EUR: 'EUR',
  '£': 'GBP',
  GBP: 'GBP',
  CA$: 'CAD',
  CAD: 'CAD',
  INR: 'INR',
  AED: 'AED',
  NZD: 'NZD',
  default: 'EUR',
};

export default function ProductPriceExact({
  pricing,
  prependPriceType = false,
  currencyDisplay,
  useGrouping,
  ...rest
}) {
  const { i18n } = useLingui();
  const priceFormat = {
    style: 'currency',
    currency: currencies[pricing.currencyCode] || currencies.default,
    currencyDisplay,
    useGrouping,
  };
  if (prependPriceType)
    return (
      <span {...rest}>
        {pricing?.priceType} {i18n.number(pricing.price, priceFormat)}
      </span>
    );
  return <span {...rest}>{i18n.number(pricing.price, priceFormat)}</span>;
}
